import { SIZE } from 'baseui/button'
import { Accordion, Panel as AccordionPanel } from 'baseui/accordion'

import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'

import useCommands from './useCommands'
import { ActionsRow, FieldsColumn, ListWrapper, NotificationsWrapper, OutputBox, Stack } from './styled-components'

const CommandsForm = () => {
  const { form, result, t } = useCommands()

  return (
    <Stack>
      <FieldsColumn>
        <SDFormControl label={t('commands.label_input')}>
          <SDInput
            currentValue={form.command}
            outerOnchange={form.onCommandChange}
            placeholder={t('commands.place_holder_input')}
            onKeyDown={event => {
              if (event.key === 'Enter') form.onExecute()
            }}
          />
        </SDFormControl>
      </FieldsColumn>

      <ActionsRow>
        <SDButton size={SIZE.compact} block={false} disabled={!form.command || form.isExecuting} onClick={form.onExecute}>
          {t('commands.execute_button')}
        </SDButton>
        <SDLoader hidden={!form.isExecuting} text={t('common:fetching_data')} />
      </ActionsRow>

      <NotificationsWrapper>
        <SDNotification type='negative' hidden={!result.error} primaryText={String(result.error || '')} />
        <SDNotification type='positive' hidden={!result.success} primaryText={t('commands.success')} />
      </NotificationsWrapper>

      <SDFormControl label={t('commands.label_output')} hidden={form.output === null}>
        <OutputBox>{form.output}</OutputBox>
      </SDFormControl>

      <ListWrapper>
        <SDFormControl label={t('commands.label_list')}>
          <>
            <SDLoader hidden={!form.isLoadingList} text={t('common:fetching_data')} />
            <SDNotification type='negative' hidden={!form.listError} primaryText={String(form.listError || '')} />
            <Accordion>
              {Object.entries(form.commandsList).map(([key, value]) => (
                <AccordionPanel key={`command-${key}`} title={value.name}>
                  <div dangerouslySetInnerHTML={{ __html: value.description }} />
                  <p>
                    <b>{t('commands.label_signature')} : {value.signature}</b>
                  </p>
                </AccordionPanel>
              ))}
            </Accordion>
          </>
        </SDFormControl>
      </ListWrapper>
    </Stack>
  )
}

export default CommandsForm
